import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_money_cn",
  "use": "icon-control_money_cn-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-control_money_cn\"><path d=\"M13.426 5.107v-.754H9.201v-.806h4.901v-.78H9.201V2h-.897v.767H3.429v.78h4.875v.806H4.248v.754h9.178zM4.235 7.785V6.641h9.009v1.144h.871V5.887H3.364v1.898h.871zm8.281.403V7.46h-7.54v.728h7.54zm1.963 5.304v-.793h-3.718l.559-1.17h1.261V8.981h-7.67v2.548h1.261l.494 1.17H3v.793h11.479zm-2.821-2.691H5.834V9.696h5.824v1.105zm-1.872 1.898H7.615l-.494-1.17h3.224l-.559 1.17z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol